export { CurrencyConverterPageTemplate } from "./CurrencyConverterPageTemplate";
